import Openable from 'utils/lib/openable';

class Modal extends Openable {
  constructor(element, overlayElement) {
    super(element, overlayElement);

    this.classes = {
      active: 'modal--active',
    };
  }
}

export default (
  element: string | HTMLElement,
  overlayElement?: HTMLElement,
): Modal => new Modal(element, overlayElement);
